import classNames from "classnames";
import {StaticImage} from "gatsby-plugin-image";
import {useCallback} from "react";
import * as React from "react";
import {pluralize} from "../../utils/number";
import Media from "../Common/Media";
import TemplateString from "../Common/TemplateString";
import Section from "../Layout/Section";
import Button from "../UI/Button";
import * as heroStyles from "./hero.module.css";

const SolutionHero = ({title, description, media, variant = "text_above", freeDaysCount = 0}) => {
    const scrollToForm = useCallback(() => {
        const form = document.querySelector("#free-demo-form");
        if (!form) {
            return;
        }

        form.scrollIntoView({behavior: "smooth"});
    }, []);

    return (
        <Section>
            <div className={classNames(heroStyles.hero, {[heroStyles.hero_textLeft]: variant === "text_left"})}>
                <h1 className={heroStyles.hero__title}>
                    <TemplateString template={title} />
                </h1>
                <p className={heroStyles.hero__desc}>
                    {description.split("\n").length === 1 ? (
                        <TemplateString template={description} />
                    ) : (
                        <ul>
                            {description.split("\n").map((line, index) => (
                                <li key={index}>
                                    <TemplateString template={line} />
                                </li>
                            ))}
                        </ul>
                    )}
                </p>
                <Button variant="primary" className={heroStyles.hero__button} onClick={scrollToForm}>
                    {freeDaysCount > 0
                        ? `${pluralize(freeDaysCount, ["%d день", "%d дня", "%d дней"])} бесплатно`
                        : "Записаться на демо"}
                </Button>
                {media && (
                    <div className={heroStyles.hero__media}>
                        <Media media={media} big={variant !== "text_left"} />
                    </div>
                )}

                <div>
                    <StaticImage
                        src="../../assets/images/solutions/desktop/gradient_1.png"
                        alt=""
                        placeholder="none"
                        layout="fixed"
                        loading="eager"
                        className={`${heroStyles.hero__gradient} ${heroStyles.hero__gradient_desktop}`}
                    />
                    <StaticImage
                        src="../../assets/images/solutions/desktop/gradient_2.png"
                        alt=""
                        placeholder="none"
                        layout="fixed"
                        loading="eager"
                        className={`${heroStyles.hero__gradient} ${heroStyles.hero__gradient_desktop}`}
                    />
                </div>

                <div>
                    <StaticImage
                        src="../../assets/images/solutions/tablet/gradient_1.png"
                        alt=""
                        placeholder="none"
                        layout="fixed"
                        loading="eager"
                        className={`${heroStyles.hero__gradient} ${heroStyles.hero__gradient_tablet}`}
                    />
                </div>

                <div>
                    <StaticImage
                        src="../../assets/images/solutions/mobile/gradient_1.png"
                        alt=""
                        placeholder="none"
                        layout="fixed"
                        loading="eager"
                        className={`${heroStyles.hero__gradient} ${heroStyles.hero__gradient_mobile}`}
                    />
                </div>
            </div>
        </Section>
    );
};

export default SolutionHero;
